import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import EditReviewInfo from "../../BookModule.module.css";
import moment from "moment";
import RatingIcon from "./RatingIcon.png";
import RatingGreyIcon from "./RatingWhiteIcon.png";
import { AxiosInstance } from "../../../../../../axios";
import toast from "react-hot-toast";

export default function EditReview() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;

  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  } else {
    console.log("UserId Not available");
  }
  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);
  const navigateToPreviousScreen = () => {
    navigate(-1); // Navigate back by one step in the history
  };
  useEffect(() => {
    findbyid(id);
  }, []);
  const review_status_ref = useRef(null);
  const [listErrors, setListErrors] = useState({});
  const [fdata, setFdata] = useState({});
  const [viewData, setViewData] = useState({});
  const findbyid = (IDSS) => {
    AxiosInstance.post("/api/book/review/viewById", {
      id: IDSS,
    })
      .then((res) => {
        if (res.data.status) {
          setIsLoading(false);
          const fiata = res?.data?.data[0];
          setFdata(fiata);
          setViewData(fiata);
        } else if (res.data.status === false) {
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        return error;
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFdata((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setListErrors((prevState) => ({
      ...prevState,
      [name]: "",
    }));
  };
  const validateEdit = (datas) => {
    const errors = {};
    if (!datas.status) {
      errors.status = "Review status is required";
    }
    validateEditFocus(datas);
    return errors;
  };

  const validateEditFocus = (objs) => {
    if (!objs.status) {
      review_status_ref.current.focus();
    }
  };
  const handleSubmit = () => {
    const errorss = validateEdit(fdata);
    if (Object.keys(errorss).length === 0) {
      const GHYU = {
        id: parseInt(id),
        status: parseInt(fdata.status),
        video_path: fdata.video_path ? fdata.video_path : "",
        created_dt: moment.utc(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        created_by: userid,
      };
      AxiosInstance.post("/api/book/addReview", GHYU)
        .then((res) => {
          if (res.data.status) {
            navigate(-1);
            toast.success(res.data.message);
          } else if (res.data.status === false) {
            navigate(-1);
            toast.error(res.data.message);
          }
        })
        .catch((error) => {
          return error;
        });
    } else {
      setListErrors(errorss);
    }
  };

  const getYouTubeID = (url) => {
    if (!url || typeof url !== "string") return "";

    const regExp =
      /(?:youtube\.com\/(?:.*[?&]v=|v\/|embed\/|shorts\/)|youtu\.be\/)([^"&?\/\s]{11})/;
    const match = url.match(regExp);
    return match ? match[1] : "";
  };
  const handleNavigate = (setN, bookId, id) => {
    if (setN == 1) {
      navigate(`/studyMaterials/Books/ViewBookSet/${bookId}/${id}`, {
        state: {
          LABEL: "Back to Edit Review",
        },
      });
    } else {
      navigate(`/viewIndividualBook/${id}`, {
        state: {
          LABEL: "Back to Edit Review",
        },
      });
    }
  };
  return (
    <div className="BathHeader global_container">
      <div className="row mx-0">
        <div className="col-md-6 col-12 px-0">
          <h2 className="TitleHeader">Edit Review Status</h2>
        </div>
        <div className="col-md-6 col-12 ListBtn px-0">
          <ul class="List-Button">
            <li class="ListBtnItems">
              <Link
                to={"javascript:void(0)"}
                onClick={navigateToPreviousScreen}
                className="secondaryButton "
                variant="secondary"
              >
                Back to View Review
              </Link>
            </li>
            <li className="ListBtnItems">
              <Link
                to={"javascript:void(0)"}
                onClick={handleSubmit}
                className="primaryButton"
              >
                Save Review Status
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="row mt-3 mb-3">
        <div className="col-xl-12 col-lg-12 col-md-12 col-12">
          <fieldset className={EditReviewInfo.preorderContainer}>
            <legend className="w-auto mb-0">Review Details</legend>
            <div className="row mx-0 mb-2">
              <div className="px-0 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Book Name</p>
                  <p
                    onClick={() =>
                      handleNavigate(
                        fdata.is_set,
                        fdata.book_ids,
                        fdata.book_id
                      )
                    }
                    style={{ cursor: "pointer" }}
                    className={`confirm_value my-1 m-0 p-0 ${EditReviewInfo.colorSkyBlue}`}
                  >
                    {fdata.book_title ? fdata.book_title : "_"}
                  </p>
                </div>
              </div>
              <div className="px-0  col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">User Name</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {fdata.username ? fdata.username : "_"}
                  </p>
                </div>
              </div>
              <div className="px-0  col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Email ID</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {fdata.email ? fdata.email : "_"}
                  </p>
                </div>
              </div>
              <div className="px-0  col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Phone Number</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {fdata.phone_no ? fdata.phone_no : "_"}
                  </p>
                </div>
              </div>
            </div>

            <div className="row mx-0 mb-2">
              <div className="px-0  col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Date</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {fdata.date ? moment(fdata.date).format("DD/MM/YYYY") : "_"}
                  </p>
                </div>
              </div>
              <div className="px-0 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <div className="d-flex">
                    <p className="confirm_label m-0 p-0">Ratings</p>
                  </div>
                  <p className="confirm_value my-1 m-0 p-0">
                    {[...Array(5)].map((_, index) => (
                      <img
                        key={index}
                        className="ms-1"
                        src={index < fdata.rating ? RatingIcon : RatingGreyIcon} // Fill stars based on rating
                        alt={
                          index < fdata.rating
                            ? "Rating Icon"
                            : "Grey Rating Icon"
                        }
                      />
                    ))}
                  </p>
                </div>
              </div>
              <div className="px-0 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <div className="d-flex">
                    <p className="confirm_label m-0 p-0">Review Status</p>
                  </div>
                  <p className="confirm_value my-1 m-0 p-0">
                    {viewData.status == 0 && "Waiting For Approval"}
                    {viewData.status == 1 && "Approved"}
                    {viewData.status == 2 && "Rejected"}
                  </p>
                </div>
              </div>
            </div>
            {fdata.video_path && (
              <div className="px-0 col-lg-12 col-md-12 col-12">
                <div className="d-flex flex-column">
                  <div className="d-flex">
                    <p className="confirm_label m-0 p-0">YouTube URL</p>
                  </div>
                  <div className=" col-lg-12 offset-md-12 col-12 mt-2  ">
                    <iframe
                      src={`https://www.youtube.com/embed/${getYouTubeID(
                        fdata.video_path
                      )}`}
                      className={`${EditReviewInfo.iframeVideo}`}
                      allowFullScreen
                      title="Dynamic Iframe"
                    ></iframe>
                  </div>
                </div>
              </div>
            )}

            <div className="row mx-0">
              <div className="px-0  col-lg-12 col-md-12 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Review</p>
                  <p className="confirm_value text-justify my-1 m-0 p-0">
                    {fdata.review ? fdata.review : "_"}
                  </p>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      <div className="row mt-3 mb-2">
        <div className="col-xl-12 col-lg-12 col-md-12 col-12">
          <fieldset className={EditReviewInfo.preorderContainer}>
            <legend className="w-auto mb-0">Review by Admin</legend>
            <div className="row mx-0">
              <div class="col-xl-6 col-lg-6 mb-3 ps-0 col-md-6 col-12 ps-0 d-flex flex-column">
                <label class="form-label confirm_value ">Review Status</label>
                <div>
                  <input
                    ref={review_status_ref}
                    className={`${EditReviewInfo.radip_input} `}
                    type="radio"
                    id="Approve"
                    name="status"
                    placeholder="Approve"
                    onChange={(e) => handleChange(e)}
                    value={1}
                    checked={fdata.status == 1 ? true : false}
                  />
                  <label
                    for="Approve"
                    class="form-label confirm_value mb-0 px-2 align-bottom"
                  >
                    Approve
                  </label>

                  <input
                    className={`${EditReviewInfo.radip_input} `}
                    type="radio"
                    id="Reject"
                    name="status"
                    onChange={(e) => handleChange(e)}
                    placeholder="Reject"
                    value={2}
                    checked={fdata.status == 2 ? true : false}
                  />
                  <label
                    for="Reject"
                    class="form-label mb-0 px-2 align-bottom confirm_value"
                  >
                    Reject
                  </label>
                </div>
                {listErrors.status && (
                  <small className={`error_message mt-2`}>
                    {listErrors.status}
                  </small>
                )}
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      <div className="row mt-3 mb-4 mx-0">
        <div className="col-md-12 col-12 ListBtn px-0">
          <ul class="List-Button">
            <li class="ListBtnItems">
              <Link
                to={"javascript:void(0)"}
                onClick={navigateToPreviousScreen}
                className="secondaryButton "
                variant="secondary"
              >
                Back to View Review
              </Link>
            </li>
            <li className="ListBtnItems">
              <Link
                to={"javascript:void(0)"}
                onClick={handleSubmit}
                className="primaryButton"
              >
                Save Review Status
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
